export default {"src":"/_next/static/media/5.7e2c9bc8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};